import React from 'react';
import styles from './Loading.module.scss';
import circleDotSvg from '../../../assets/images/circleDot.svg';

const Loading = ({ loading, title, description }) => {
    return loading ? (
        <div className={styles.loading}>
            <div className={styles.center}>
                <img src={circleDotSvg} className={styles.spinner} alt='spinner' />
                <h4>{title}</h4>
                <p>{description}</p>
            </div>
        </div>
    ) : null;
};

export default Loading;
